import {Dimensions, Platform, StyleSheet} from 'react-native';

const windowW = Dimensions.get('window').width;

export const styles = StyleSheet.create({
  container: {flex: 1},
  scrollContainer: {
    flex: 1,
    paddingHorizontal: 10,
    paddingVertical: 20,
    backgroundColor: 'transparent',
  },
  itemContainer:
    Platform.OS === 'web' && windowW > 768
      ? {
          backgroundColor: 'white',
          justifyContent: 'space-between',
          flexDirection: 'row',
          flexWrap: 'wrap',
          marginBottom: 20,
          padding: 10,
          shadowColor: 'rgba(15, 87, 158, 0.9)',
          shadowOffset: {
            width: 1,
            height: 2,
          },
          shadowOpacity: 0.4,
          shadowRadius: 7,
          elevation: 5,
          borderRadius: 20,
          width: '100%',
        }
      : {
          flexDirection: 'column',
          backgroundColor: 'white',
          borderRadius: 20,
          elevation: 4,
          shadowColor: 'gray',
          paddingHorizontal: 10,
          paddingVertical: 20,
          marginHorizontal: 10,
          marginVertical: 10,
        },
  btnValider: {
    color: '#fff',
    fontWeight: '700',
    textAlign: 'center',
    marginHorizontal: 8,
    paddingHorizontal: 10,
    margin: 0,
    fontSize: 14,
  },
  btnValiderOuter: {
    backgroundColor: '#0f579e',
    borderRadius: 30,
    height: 50,
    shadowColor: 'rgba(15, 87, 158, 0.9)',
    shadowOffset: {
      width: 1,
      height: 2,
    },
    shadowOpacity: 0.4,
    shadowRadius: 7,
    elevation: 5,
    marginVertical: 8,
    flexGrow: 0,
    flexShrink: 1,
    paddingHorizontal: 1,
    marginHorizontal: 5,
    minWidth: 1,
  },
});
